import {Col, Row} from "react-simple-flex-grid";
import Tabs from "./Tabs";
import TabPane from "./Tab";
import '../styles/ArtificialIntelligence.scss'
import {Chip} from "./Chip";
import aIVisitorImage from '../images/ai_visitor_image.png';
import aiTemplateImage from '../images/ai_template_img.png';
import aiResultImage from '../images/ai_result_img.png';
import compVisionImage from '../images/machine_learning_tab_bg.png';
import img1 from '../images/tech_tab_ml_images/avatars/1.png';
import img2 from '../images/tech_tab_ml_images/avatars/2.png';
import img3 from '../images/tech_tab_ml_images/avatars/3.png';
import img4 from '../images/tech_tab_ml_images/avatars/4.png';
import img5 from '../images/tech_tab_ml_images/avatars/5.png';
import img6 from '../images/tech_tab_ml_images/avatars/6.png';
import img7 from '../images/tech_tab_ml_images/avatars/7.png';
import img8 from '../images/tech_tab_ml_images/avatars/8.png';
import img9 from '../images/tech_tab_ml_images/avatars/9.png';
import img10 from '../images/tech_tab_ml_images/avatars/10.png';
import img11 from '../images/tech_tab_ml_images/avatars/11.png';
import img12 from '../images/tech_tab_ml_images/avatars/12.png';

export const ArtificialIntelligence = () => {
    const genAIChips = ['retail', 'content marketing', 'automotive', 'healthcare', 'urban planning', 'product design']
    const compVisionChips = ['retail', 'security', 'manufacturing', 'healthcare', 'automotive', 'agriculture', 'logistic']
    const machineLearningIChips = ['e-commerce', 'retail', 'manufacturing', 'healthcare', 'financial services', 'energy']
    const imagesArray = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12];

    return <>
        <Row>
            <Col span={6}>
                <h3 className="section-title">
                    Artificial intelligence
                </h3>
                <h5 className="section-subtitle">
                    Face recognition = <br/> gender + race + beautification filters
                </h5>
            </Col>
        </Row>
        <Row>
            <Col span={12}>
                <Tabs>
                    <TabPane title="Gen AI">
                        <div className="tab-body">
                            <div className="tab-body-header">
                                <Row gutter={20}>
                                    <Col xs={12} sm={6}>
                                        <p className="content-text">
                                            We applied GenAI to generate in real-time a digital avatar of the visitor by
                                            capturing visitor’s face features and blending it with the randomly assigned
                                            avatar
                                            template pre-generated in MidJourney by the creator @Immersive Ash.
                                        </p>
                                    </Col>
                                    <Col xs={12} sm={6}>
                                        <h5 className="chips-title">applicable to</h5>
                                        <div className="chips-container small-chips">
                                            {genAIChips.length && genAIChips.map((item: string, index) => {
                                                return <Chip key={index} chip={item}/>
                                            })}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="ai-images">
                                <Row gutter={30}>
                                    <Col xs={12} sm={7}>
                                        <div className="ai-images-block">
                                            <div className="ai-images-content">
                                                <Row gutter={10}>
                                                    <Col span={6}>
                                                        <div className="ai-image">
                                                            <h5 className="content-title">Visitor Image</h5>
                                                            <img className="content-img" src={aIVisitorImage}></img>
                                                        </div>
                                                    </Col>
                                                    <Col span={6}>
                                                        <div className="ai-image">
                                                            <h5 className="content-title">Template</h5>
                                                            <img className="content-img" src={aiTemplateImage}></img>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={5} xs={12} sm={5}>
                                        <div className="ai-images-block last-block">
                                            <div className="ai-images-content">
                                                <Row gutter={10}>
                                                    <Col span={12}>
                                                        <div className="ai-image">
                                                            <h5 className="content-title">Result</h5>
                                                            <img className="content-img" src={aiResultImage}></img>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </TabPane>
                    <TabPane title="computer vision">
                        <div className="tab-body">
                            <div className="tab-body-header">
                                <Row gutter={20}>
                                    <Col xs={12} sm={6}>
                                        <p className="content-text">
                                            Computer vision captures the visitor’s face features real-time using the
                                            web-camera on top of the kiosk.
                                        </p>
                                    </Col>
                                    <Col xs={12} sm={6}>
                                        <h5 className="chips-title">applicable to</h5>
                                        <div className="chips-container small-chips">
                                            {compVisionChips.length && compVisionChips.map((item: string, index) => {
                                                return <Chip key={index} chip={item}/>
                                            })}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="ai-images">
                                <Row gutter={30}>
                                    <Col span={12}>
                                        <img className="content-img computer-vision-bg" src={compVisionImage}></img>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </TabPane>
                    <TabPane title="Machine Learning">
                        <div className="tab-body">
                            <div className="tab-body-header">
                                <Row gutter={20}>
                                    <Col xs={12} sm={6}>
                                        <p className="content-text">
                                            We developed own neural network, that allows to recognise the gender and the
                                            race of the visitor real-time, generate the digital avatar and improve the
                                            visual representation of it.
                                        </p>
                                    </Col>
                                    <Col xs={12} sm={6}>
                                        <h5 className="chips-title">applicable to</h5>
                                        <div className="chips-container small-chips">
                                            {machineLearningIChips.length && machineLearningIChips.map((item: string, index) => {
                                                return <Chip key={index} chip={item}/>
                                            })}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="ai-images">
                                <Row>
                                    <div className="result-images">
                                        {imagesArray.map((path, index) => (
                                            <Col span={2}>

                                                <img key={index} src={path} alt={`result ${index + 1}`}/>
                                            </Col>
                                        ))}
                                    </div>
                                </Row>
                            </div>
                        </div>
                    </TabPane>
                </Tabs>
            </Col>
        </Row>
    </>
}